var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoccerball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66965 4.31403V6.99171H8.33081V4.31403H9.66965Z",
    fill: "#0577FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00011 2.9752C5.66639 2.9752 2.97532 5.66627 2.97532 8.99999C2.97532 12.327 5.66639 15.0248 9.00011 15.0248C10.598 15.0248 12.1304 14.39 13.2603 13.2602C14.3902 12.1303 15.0249 10.5979 15.0249 8.99999C15.0249 5.66627 12.3271 2.9752 9.00011 2.9752ZM1.63647 8.99999C1.63647 4.92991 4.93003 1.63635 9.00011 1.63635C13.0635 1.63635 16.3637 4.92991 16.3637 8.99999C16.3637 13.0634 13.0635 16.3636 9.00011 16.3636C4.93003 16.3636 1.63647 13.0634 1.63647 8.99999Z",
    fill: "#0577FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59173 6.45619C8.82603 6.26875 9.16074 6.26875 9.40173 6.45619L11.0887 7.74817L13.3982 6.71057L13.9404 7.92892L11.5372 8.99999L10.9883 10.7539L12.7355 12.1396L11.8987 13.1839L9.97074 11.6509H7.94909L6.02116 13.1772L5.18438 12.1262L6.93157 10.7338L6.38264 8.95313L4.28735 7.88206L4.89653 6.68379L6.85793 7.68793L8.52479 6.40933L8.59173 6.45619ZM7.76165 8.7657L8.24363 10.3254H9.73644L10.2184 8.759L8.98669 7.81512L7.75496 8.75231L7.76165 8.7657Z",
    fill: "#0577FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59182 4.70236C8.82612 4.8831 9.16083 4.8831 9.40182 4.70236L11.4101 3.16269L10.5934 2.09831L8.98678 3.31666L7.38017 2.09161L6.56348 3.1493L8.56505 4.68228L8.59182 4.70236Z",
    fill: "#0577FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59182 4.70236C8.82612 4.8831 9.16083 4.8831 9.40182 4.70236L11.4101 3.16269L10.5934 2.09831L8.98678 3.31666L7.38017 2.09161L6.56348 3.1493L8.56505 4.68228L8.59182 4.70236Z",
    fill: "#0577FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30246 12.5546C6.24891 12.2533 6.00792 12.0257 5.70668 11.9923L3.18965 11.7312L3.04907 13.0567L5.05064 13.2642L5.37196 15.2524L6.69073 15.0314L6.27568 12.5345L6.30246 12.5546Z",
    fill: "#0577FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6308 12.5546C11.6777 12.2533 11.9187 12.0257 12.2199 11.9923L14.7302 11.7312L14.8641 13.0567L12.8559 13.2642L12.5278 15.2524L11.2024 15.0314L11.6107 12.5345L11.6308 12.5546Z",
    fill: "#0577FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93007 7.94902C5.17775 7.78166 5.29155 7.46704 5.20453 7.17918L4.44808 4.76257L3.16949 5.15753L3.76527 7.07877L2.06494 8.16323L2.78122 9.28786L4.90329 7.92224L4.93007 7.94902Z",
    fill: "#0577FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1438 7.94902C12.8894 7.78166 12.7756 7.46704 12.8627 7.17918L13.6124 4.76257L14.8843 5.15753L14.2818 7.07877L15.9755 8.16323L15.2525 9.28786L13.1237 7.92224L13.1438 7.94902Z",
    fill: "#0577FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerball);
export default __webpack_public_path__ + "static/media/soccerball.c87add47a955b9d3f5641a82b70c10a2.svg";
export { ForwardRef as ReactComponent };